<template>
	<div class="main" v-if="loaded">
		<header class="page-title" style="flex-direction: row;justify-content: space-between;">
			<h2>{{ provider.name }} &ndash; Commercial</h2>
			<div style="float: right">
				<label class="label-checkbox">
					<input name="affiliate" type="checkbox" @change="saveAffiliate" v-model="provider.affiliate">
					<span>Has affiliate partnership</span>
				</label>
			</div>
		</header>


		<provider-affiliate-links
				:providerid="providerId"
				v-if="userRoles.includes('affiliate_links.listAll')">
		</provider-affiliate-links>

		<provider-commercial-alternatives
				:providerid="providerId"
				v-if="userRoles.includes('providers.update')">
		</provider-commercial-alternatives>

		<!--<hr>

		<section>
			<header class="section-title">
				<h3>Affiliate Panels</h3>
				<a href="single-provider__commercial-tab__create-edit-affiliate-panel-modal" class="btn btn-md btn-success"><i class="fas fa-plus" title="Add"></i> New Affiliate Panel</a>
			</header>
			<div class="table-reponsive">
				<table>
					<thead>
						<tr>
							<th>URL</th>
							<th>Username</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>https://expressvpn.com/login?from=proprivacy.com</td>
							<td>ProPrivacyAff</td>
							<td class="nowrap">
								<a href="single-provider__commercial-tab__create-edit-affiliate-panel-modal" class="btn btn-icon btn-primary" title="Edit"><i class="fas fa-pencil-alt"></i></a>
								<a href="#" class="btn btn-icon btn-danger" title="Delete"><i class="fas fa-trash-alt"></i></a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>-->
	</div>
</template>

<script>
	export default {
		props: {
			providerid: {
				type: Number
			}
		},
		data() {
			return {
				tabName: 'commercialContainer',
				loaded: false,
				provider: {},
				providerId: this.providerid,
				userRoles: this.$currentUserRoles,
			}
		},
		created() {
			this.fetchDataFromApi();
		},
		methods: {
			fetchDataFromApi: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/providers/fetchtabdata/' + vm.providerId, {
					tab: vm.tabName
				})
					.then(response => {
						if (response.data.hasOwnProperty('provider')) {
							vm.provider = response.data.provider;
						}
						vm.loaded = true;
					})
					.catch(e => {
						vm.$toastr.error('Api ' + vm.tabName + ' tab load failed', 'Error');
					});
			},
			saveAffiliate: function () {
				let vm = this;
				
				axios.post('/api/' + vm.$selectedSite.slug + '/providers/' + vm.provider.id + '/has-affiliate',
					{
						affiliate: vm.provider.affiliate
					})
					.then(response => {
						vm.$toastr.success(vm.provider.name + ' affiliate status change was successfully done', 'Success');
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						this.$toastr.error('Has affiliate saving failed.', 'Error');
					});
			},
		}
	}
</script>

<style scoped>

</style>
